"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var children_exports = {};
__export(children_exports, {
  filterAllowedChildrenElements: () => filterAllowedChildrenElements,
  getAllChildrenNotOfType: () => getAllChildrenNotOfType,
  getAllChildrenOfType: () => getAllChildrenOfType,
  getFirstChildOfType: () => getFirstChildOfType,
  isChildOfType: () => isChildOfType
});
module.exports = __toCommonJS(children_exports);
var import_react = require("react");
function isChildOfType(element, type) {
  return (0, import_react.isValidElement)(element) && element.type === type;
}
function getFirstChildOfType(children, type) {
  var childArray = Array.isArray(children) ? children : [
    children
  ];
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = childArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var child = _step.value;
      if (isChildOfType(child, type)) {
        return child;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return void 0;
}
function getAllChildrenOfType(children, type) {
  var childArray = Array.isArray(children) ? children : [
    children
  ];
  return childArray.filter(function(child) {
    return isChildOfType(child, type);
  });
}
function getAllChildrenNotOfType(children, type) {
  var childArray = Array.isArray(children) ? children : [
    children
  ];
  return childArray.filter(function(child) {
    return !isChildOfType(child, type);
  });
}
function filterAllowedChildrenElements(children, allowedTypes) {
  var childArray = Array.isArray(children) ? children : [
    children
  ];
  return childArray.filter(function(child) {
    return (0, import_react.isValidElement)(child) && allowedTypes.some(function(type) {
      return child.type === type;
    });
  });
}
//# sourceMappingURL=children.js.map
